<template>
    <RouterView />
</template>

<script lang="ts">
    import { defineComponent } from 'vue'

    export default defineComponent({
        name: 'Blank'
    })
</script>
